import { faSyncAlt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const StyledLoading = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 200px;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.palette.grey[0]};
  padding: 3rem;
`

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid ${(props) => props.theme.palette.grey[200]};
  border-top: 4px solid ${(props) => props.theme.palette.primary[700]};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`

const StyledSmallLoading = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.palette.primary[700]};
  font-size: 1rem;
`

export const IWSmallLoading = () => {
  return <StyledSmallLoading icon={faSyncAlt} spin />
}

/**
 * Simple loading component, displays a spinner in the center of a white div.
 *
 */
const IWLoading = () => {
  return (
    <StyledLoading data-testid="loading">
      <Spinner />
    </StyledLoading>
  )
}

export default IWLoading
